<template>
<div>
    <div class="sub_visual_wrap">
        <div class="sub_visual_box container">
            <div class="page_nav">
                <ul>
                    <li><router-link to="/main" @click.native="$store.commit('setActive','')">{{$t('common.home')}}</router-link></li>
                    <li><a href="#">{{$t('common.product')}}</a></li>
                </ul>
            </div>
            <h2>{{$t('common.product')}}</h2>
        </div>
    </div>
    <section class="container">
        <router-view></router-view>
    </section>
</div>    
</template>

<script>
export default {

}
</script>

<style>

</style>